import React, { useState } from "react";
import { skillsSection } from "../data/data";
import SkillEcommerce from "../modules/SkillEcommerce";
import SkillMarketplace from "../modules/SkillMarketplace";
import SkillBase from "../modules/SkillBase";
import SkillGrafika from "../modules/SkillGrafika";
import SkillAutomatyzacje from "../modules/SkillAutomatyzacje";
import SkillJS from "../modules/SkillJS";
import "./Skills.css";

const skillModules = {
  ecommerce: SkillEcommerce,
  marketplace: SkillMarketplace,
  base: SkillBase,
  grafika: SkillGrafika,
  automatyzacje: SkillAutomatyzacje,
  js: SkillJS
};

const Skills = () => {
  const [modalSkill, setModalSkill] = useState(null);
  const [iconError, setIconError] = useState({});

  const handleIconError = (id) => {
    setIconError((prev) => ({ ...prev, [id]: true }));
  };

  const handleOpenModal = (skill) => {
    setModalSkill(skill);
  };

  const handleCloseModal = () => {
    setModalSkill(null);
  };

  return (
    <section className="skills" id="skills">
      <h2>{skillsSection.heading}</h2>
      <p className="skills-subheading">{skillsSection.subheading}</p>
      <div className="skills-list">
        {skillsSection.skills.map((skill) => {
          return (
            <div
              key={skill.id}
              className="skill-item"
              tabIndex={0}
              role="button"
              aria-pressed={false}>
              <div className="skill-icon img-container">
                {!iconError[skill.id] ? (
                  <img
                    src={skill.icon}
                    alt={skill.title}
                    onError={() => handleIconError(skill.id)}
                  />
                ) : (
                  <span className="img-placeholder">miejsce na grafikę</span>
                )}
              </div>
              <h3>{skill.title}</h3>
              <p>{skill.short}</p>
              <button
                className="skill-more-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenModal(skill);
                }}>
                czytaj więcej
              </button>
            </div>
          );
        })}
      </div>
      {modalSkill && (
        <div className="skill-modal-overlay" onClick={handleCloseModal}>
          <div className="skill-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="skill-modal-close"
              onClick={handleCloseModal}
              aria-label="Zamknij">
              &times;
            </button>
            <h3>{modalSkill.title}</h3>
            <div className="skill-modal-details">
              {skillModules[modalSkill.id] ? (
                React.createElement(skillModules[modalSkill.id])
              ) : (
                <p>{modalSkill.details}</p>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Skills;
